import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import BackBar from "../components/BackBar";
import MemberDirectory from "../components/MemberDirectory";
import { Link } from "react-router-dom";
import Brand from "../components/Brand";

export default function DirectoryPage({ embedded = false }) {
  return (
    <div className="min-h-screen bg-ivory" data-testid="directory-page">
      {!embedded && <SiteNav />}
      {!embedded && <BackBar />}
      <section className="max-w-6xl mx-auto px-6 md:px-8 py-10">
        <MemberDirectory />
      </section>

      {/* Bottom CTA */}
      <section className="max-w-3xl mx-auto px-6 md:px-8 pb-16">
        <div className="rounded-2xl bg-gradient-to-r from-[#0F172A] to-[#2A2521] text-white p-6 md:p-8 shadow-2xl border-2 border-[#F39A1F]/40 text-center">
          <div className="text-[10px] tracking-wider-cap font-bold text-[#F39A1F]">★ 7-DAY FREE TRIAL</div>
          <div className="font-serif-display text-3xl uppercase mt-1">Want your face in here?</div>
          <p className="text-white/80 mt-1">7-Day Free Trial · <Brand suffix=".com"/>/u/your-name · funnel · upgrade to unlock the affiliate program. No card.</p>
          <Link to="/signup?plan=free" className="btn-primary mt-5 inline-block">Claim My Free Page</Link>
        </div>
      </section>
      {!embedded && <SiteFooter />}
    </div>
  );
}
